'use client'

import { useQueryResults } from "@/hooks/useQueryResults"
import { useMemo } from "react"
import moment from "moment"
import { DatasetLineChart } from "./charts/dataset-line-chart"

export function MorphoSTUSDS() {
    const { results } = useQueryResults({id: 6777432})

    const dataset = useMemo(() => {
        if (!results) return {dimensions: [], source: []}
        
        const series = [...new Set(results.map(r => r.name)).keys()] as any as string[]
        const days = [...new Set(results.map(r => r.day.valueOf()))]

        return {
            dimensions: ['date', ...series],
            source: days.map(d => {
                const filtered = results.filter(r => r.day.valueOf() === d)
                return [new Date(d), ...series.map(s => filtered.find(r => r.name === s)?.balance ?? 0)]
            })
        }
    }, [results])

    return <div className='h-[40vh]'>
            <DatasetLineChart
                title="Sky.money Curated Morpho Vaults"
                dataset={dataset}
                tooltip={{
                    xAxisFormatter: (v: Date) => {
                        return moment.utc(v).format("YYYY-MM-DD HH:mm")
                    },
                    seriesValueFormatter: (v) => new Intl.NumberFormat('en', {maximumFractionDigits: 0}).format(v),
                }}
                customAxes="yes"
                stack={false}
                yAxes={[
                    {preset: 'number', position: 'left'}
                ] as const}
                showTotal
            />
        </div>
}
